import modal from "src/components/ui-components/Modal/ModalContent.module.css";
import { ModalWithoutTrigger } from "src/components/ui-components/Modal";
import { Button } from "src/components/ui-components/Button/Button";
import { AnchorButton } from "src/components/ui-components/Button/AnchorButton";
import { StripeSessionButton } from "shared/StripeSessionButton/StripeSessionButton";
import { Identity } from "src/components/ui-components/Identity";

import { useEffect } from "react";
import Amplitude from "src/services/amplitude";

import type { ActiveContext } from "shared/ContextSwitcher/store";

export function UnpaidInvoiceModal({
  close,
  isOpen,
  activeContext,
}: {
  close: () => void;
  isOpen: boolean;
  activeContext: ActiveContext;
}) {
  return (
    <ModalWithoutTrigger
      isOpen={isOpen}
      onDismiss={undefined}
      size="L"
      label="Unpaid invoice"
      content={<ModalContent close={close} activeContext={activeContext} />}
    />
  );
}

function ModalContent({
  close,
  activeContext,
}: {
  close: () => void;
  activeContext: ActiveContext;
}) {
  useEffect(() => {
    Amplitude.trackEvent(`Unpaid Invoice Modal Opened`);
  }, []);

  function trackClick(button_text: string) {
    Amplitude.trackEvent(`Unpaid Invoice Modal Button Clicked`, {
      button_text,
    });
  }

  return (
    <div className={modal.body}>
      <div className={modal.header}>
        <div className={modal.titleRow}>
          <h2>Your last payment failed</h2>

          <Identity
            size="M"
            color="text-secondary"
            flip
            owner={activeContext}
          />
        </div>

        <p className={modal.description}>
          We have failed to renew your subscription, and{" "}
          <strong>will downgrade your team to Free</strong> if we repeatedly
          fail to collect payment. Please make sure you have enough funds on
          your card, or add a different card.
        </p>
      </div>

      <div className={modal.buttons}>
        <Button
          size="M"
          theme="danger"
          onClick={() => {
            close();
            trackClick("Remind me later");
          }}
        >
          Remind me later
        </Button>

        <hr className={modal.gapFillMiddle} />

        <AnchorButton
          size="M"
          theme="tertiary"
          href={getSubscriptionSettingsUrl(activeContext)}
          onClick={() => {
            close();
            trackClick("Subscription");
          }}
          onAuxClick={() => trackClick("Subscription")}
        >
          Subscription
        </AnchorButton>

        <StripeSessionButton
          checkoutOwner={activeContext}
          renderButton={({ onClick }) => (
            <Button
              size="M"
              theme="primary"
              onClick={() => {
                onClick();
                trackClick("Update card");
              }}
            >
              Update card
            </Button>
          )}
        />
      </div>
    </div>
  );
}

function getSubscriptionSettingsUrl(activeContext: ActiveContext) {
  return `${getSettingsUrl(activeContext)}/subscription`;
}

function getSettingsUrl(activeContext: ActiveContext) {
  switch (activeContext.type) {
    case "user":
      return "/settings";
    case "team":
      return `/settings/teams/manage/${activeContext.handle}`;
  }
}
